export const PORTAL_SIGN_IN_PATH = "/auth";

export interface AccessGateState {
  hasUser: boolean;
  roleLoading: boolean;
  membershipLoading: boolean;
  roleError: boolean;
  membershipError: boolean;
  isAdmin: boolean;
  isActiveMember: boolean;
}

export function evaluateAccessGate(state: AccessGateState): "signed-out" | "loading" | "retry" | "allowed" | "denied" {
  if (!state.hasUser) return "signed-out";
  if (state.isAdmin) return "allowed";
  if (state.roleLoading || state.membershipLoading) return "loading";
  if (state.roleError || state.membershipError) return "retry";
  return state.isActiveMember ? "allowed" : "denied";
}